define.alias("ember-composable-helpers/helpers/object-at", "media/helpers/object-at");